import type { ExtensionPackage } from "./types";

/** Fixed extension package IDs are stable; configure content applicability separately. */
export const extensionPackages: readonly ExtensionPackage[] = [
  { id: 1, name: "7.2技能动画扩展包" },
];
